<!-- TODO temporary layout waiting for design -->
<ng-template #loading [ngIf]="!hasError">
  <div class="loading-container">
    <app-text [text]="'common-app.__LOADING' | AsyncLang | async"></app-text>
    <app-loading-circle size="72px"></app-loading-circle>
  </div>
</ng-template>